/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Story_SubscribersInputs */

const en_story_subscribers = /** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subscribers`)
};

const es_story_subscribers = /** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suscriptores`)
};

const fr_story_subscribers = /** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Souscripteurs`)
};

const de_story_subscribers = /** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abonnenten`)
};

const id_story_subscribers = /** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pelanggan`)
};

/** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */
const ja_story_subscribers = en_story_subscribers;

/** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */
const zh_story_subscribers = en_story_subscribers;

/** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */
const ar_story_subscribers = en_story_subscribers;

/** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */
const it_story_subscribers = en_story_subscribers;

/** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */
const ru_story_subscribers = en_story_subscribers;

/** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */
const pt_story_subscribers = en_story_subscribers;

/** @type {(inputs: Story_SubscribersInputs) => LocalizedString} */
const ko_story_subscribers = en_story_subscribers;

/**
* | output |
* | --- |
* | "Subscribers" |
*
* @param {Story_SubscribersInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const story_subscribers = /** @type {((inputs?: Story_SubscribersInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Story_SubscribersInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_story_subscribers(inputs)
	if (locale === "es") return es_story_subscribers(inputs)
	if (locale === "fr") return fr_story_subscribers(inputs)
	if (locale === "de") return de_story_subscribers(inputs)
	if (locale === "ja") return ja_story_subscribers(inputs)
	if (locale === "zh") return zh_story_subscribers(inputs)
	if (locale === "ar") return ar_story_subscribers(inputs)
	if (locale === "id") return id_story_subscribers(inputs)
	if (locale === "it") return it_story_subscribers(inputs)
	if (locale === "ru") return ru_story_subscribers(inputs)
	if (locale === "pt") return pt_story_subscribers(inputs)
	return ko_story_subscribers(inputs)
});